import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Scissors, Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { tr } from '@/contexts/LanguageContext';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="not-found-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-md w-full text-center"
      >
        {/* Decorative 404 */}
        <div className="relative mb-8">
          <motion.h1
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.1, type: 'spring', stiffness: 200, damping: 15 }}
            className="font-display text-[160px] sm:text-[200px] font-bold leading-none text-gradient-gold select-none"
          >
            404
          </motion.h1>
          <motion.div
            initial={{ opacity: 0, rotate: -20, scale: 0.5 }}
            animate={{ opacity: 1, rotate: -12, scale: 1 }}
            transition={{ delay: 0.3, type: 'spring', stiffness: 200 }}
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          >
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-background/80 backdrop-blur-md border-2 border-primary rounded-2xl flex items-center justify-center shadow-gold">
              <Scissors className="w-8 h-8 sm:w-10 sm:h-10 text-primary" strokeWidth={2.5} />
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.4 }}
        >
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground mb-3">{tr("Te perdiste en Ziyup")}</h2>
          <p className="text-muted-foreground mb-8 leading-relaxed">{tr("La página que buscas no existe o fue movida. Regresa al feed y sigue descubriendo el mejor contenido de barbería.")}</p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              data-testid="not-found-back-btn"
              className="border-border hover:bg-secondary gap-2 rounded-xl"
            >
              <ArrowLeft className="w-4 h-4" />{tr("Volver")}</Button>
            <Button
              onClick={() => navigate('/feed')}
              data-testid="not-found-home-btn"
              className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold gap-2 rounded-xl shadow-gold"
            >
              <Home className="w-4 h-4" />{tr("Ir al Feed")}</Button>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
}
